import { queryFetch } from '@services/api';
import { useMutation } from '@tanstack/react-query';
import { useJobRefetch } from '@hooks/job/refetch';
import { useShowErrorToast } from '@utils/formHelpers';
import { DefaultApiResp } from '@root/globalTypes';

export const useRemoveExternalSchedule = ({
  id,
  jobId,
  taskId,
  callback,
}: {
  id: string;
  jobId: string;
  taskId?: string;
  callback?: (data: DefaultApiResp) => void;
}) => {
  const { refetch, stages } = useJobRefetch({ schedule: { type: 'external', action: 'remove' } });
  const { showErrorToast } = useShowErrorToast();

  const { mutate, isPending } = useMutation({
    mutationFn: (): Promise<DefaultApiResp> =>
      queryFetch({
        url: `jobs/${jobId}/external_schedules/${id}`,
        opt: { method: 'DELETE' },
      }),
    onMutate: async () =>
      stages.update({ jobId, task: { id: taskId, schedule: undefined, status: 'to_schedule' } }),
    onError: (err, _, prev) => {
      console.error(err);
      stages.restore(jobId, prev);
    },
    onSuccess: async ({ success }) => {
      if (!success) return;
      await refetch();
    },
    onSettled: (data) => {
      const { errors } = data as DefaultApiResp;
      if (errors) showErrorToast(errors);
      if (callback && data) callback(data);
    },
  });

  return {
    mutate,
    isLoading: isPending,
  };
};
